export default () => {
	$( '.js-quantity-field' ).on( 'click', '.plus', function ( e ) {
		e.preventDefault();
		let $input = $( this ).prev( 'input.qty' );
		let val = parseInt( $input.val() );

		$input.val( val + 1 );
		$input[ 0 ].dispatchEvent( new Event( 'change' ) );
	} );

	$( '.js-quantity-field' ).on(
		'click',
		'.minus',
		function ( e ) {
			e.preventDefault();
			let $input = $( this ).next( 'input.qty' );
			let val = parseInt( $input.val() );

			if ( val > 0 ) {
				$input.val( val - 1 );
				$input[ 0 ].dispatchEvent( new Event( 'change' ) );
			}
		}
	);
};
